import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, ConfigProvider, InputNumber, Radio, Space, notification, Checkbox, DatePicker, Table, Col, Row, Card, Alert } from 'antd';
import { Link } from 'react-router-dom';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import ResultParte1 from './components/ResultParte1'
import ResultParte2 from './components/ResultParte2'
import changeHeight from '../../data/changeHeight';
import FormularioParte2 from "./components/FormularioParte2";
import FormularioParte3 from './components/FormularioParte3';
import axios from 'axios';
import ResultPaginaPrincipalParte3 from './components/ResultParte3';
import esES from 'antd/es/locale/es_ES';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

const dateFormat = 'DD/MM/YYYY';

const LandingCaserInsurcab = () => {
    const [buttonLoading, setbuttonLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [primaryColor, setPrimaryColor] = useState('#FFFFFF');
    const [searchParams] = useSearchParams();
    const [form] = Form.useForm();
    const refForm = useRef(0);
    const [value, setValue] = useState("");
    const [datosForm, setDatosForm] = useState({});
    const [paso, setPaso] = useState(0);
    const [api, contextHolder] = notification.useNotification();
    const [NotEnsureFields, setNotEnsureFields] = useState(false);
    const [priceBasic, setPriceBasic] = useState(null);
    const [pricePremium, setPricePremium] = useState(null);
    const [isBanco, setIsBanco] = useState(true);
    const [language, setLanguage] = useState('es');
    //Cálculo edad

    const texts = {
        es: {
            p1: '¿Cuánto pagas al año por tu seguro de vida? (€) *',
            rule1: 'Por favor, ingresa el importe de tu seguro',
            p2: '¿Con quién tienes la póliza contratada actualmente? *',
            rule2: 'Indique la procedencia del seguro',
            p2_1: 'Banco',
            p2_2: 'Aseguradora',
            p2_3: 'No tengo seguro a día de hoy',
            p2_alert: 'Esta modalidad no está disponible actualmente, contacta con tu agente de Insurcab para obtener más información.',
            p3: '¿Dónde te llamamos? *',
            rule3: 'Por favor, ingresa tu teléfono',
            p4: '¿Dónde te podemos enviar el email? *',
            rule4: 'Por favor, ingresa tu email',
            placeholder4: 'tunombre@gmail.com',
            p5_1: 'Acepto los ',
            p5_2: 'términos y condiciones',
            rule5: 'Por favor, acepta los términos y condiciones',
            button: 'Ver mi precio',
            sending: 'Enviando...',
            error: 'Error inesperado',
            error_description: 'Ha ocurrido un error inesparado. Intentelo más tarde. Disculpe las molestias',
            error_minimum: 'El importe mínimo en caso de que tu seguro venga de una aseguradora es de 150€'
        },
        en: {
            p1: 'How much do you pay annually for your life insurance? (€) *',
            rule1: 'Please enter the amount of your insurance',
            p2: 'Who do you currently have the policy with? *',
            rule2: 'Indicate the origin of the insurance',
            p2_1: 'Bank',
            p2_2: 'Insurance company',
            p2_3: 'I do not have insurance today',
            p2_alert: 'This modality is not currently available, contact your Insurcab agent for more information.',
            p3: 'Where can we call you? *',
            rule3: 'Please enter your phone number',
            p4: 'Where can we send you the email? *',
            rule4: 'Please enter your email',
            placeholder4: 'yourname@gmail.com',
            p5_1: 'I accept the ',
            p5_2: 'terms and conditions',
            rule5: 'Please accept the terms and conditions',
            button: 'See my price',
            sending: 'Sending...',
            error: 'Unexpected error',
            error_description: 'An unexpected error has occurred. Try again later. Sorry for the inconvenience',
            error_minimum: 'The minimum amount in case your insurance comes from an insurer is €150'
        }
    };

    const calculateAge = (birthdate) => {
        if (!birthdate) return null;
        return dayjs().diff(dayjs(birthdate), 'years');
    };

    const handleBirthdayChange = (date) => {
        form.setFieldsValue({ capital_to_ensure: null });
    };

    const disabledDateBefore18YearsAgo = (current) => {
        const eighteenYearsAgo = dayjs().subtract(18, 'years');
        return current && current > eighteenYearsAgo;
    };


    useEffect(() => {
        if (searchParams.get("primaryColor")) {
            setPrimaryColor('#' + searchParams.get("primaryColor"));
        }
        if (searchParams.get("parentUrl")) {
            form.setFieldsValue({ url: decodeURIComponent(searchParams.get("parentUrl")) });
        }
        const url = decodeURIComponent(searchParams.get("parentUrl"));
        // form.setFieldsValue({ nombre_agente: '2499LMC1' });
        
        // Si la URL incluye "/en/" se cambiará el idioma a inglés
        if (url && url.includes("/en/")) {
            setLanguage('en');
        }
    }, [searchParams]);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.target === refForm.current) {
                    changeHeight(entry.target.clientHeight);
                    break;
                }
            }
        });

        resizeObserver.observe(refForm.current);

        return () => {
            resizeObserver.unobserve(refForm.current);
        };
    }, []);

    window.addEventListener('message', (event) => {
        if (event.data.type === "from-parent") {
            if (event.data.fbp === 'null' || event.data.fbp === null || event.data.fbp === undefined) {
                form.setFieldsValue({ fbp: " " });
            } else {
                form.setFieldsValue({ fbp: event.data.fbp });
            }
            if (event.data.hubspotutk === 'null' || event.data.hubspotutk === null || event.data.hubspotutk === undefined) {
                form.setFieldsValue({ hubspotutk: " " });
            } else {
                form.setFieldsValue({ hubspotutk: event.data.hubspotutk });
            }
            if (event.data.userAgent) { form.setFieldsValue({ userAgent: event.data.userAgent }); }
            changeHeight(refForm.current.clientHeight);
        }
    });

    const onFinish = async (values)=> {
        setbuttonLoading(true);

        const headers = {
            "Content-Type": "application/json"
        }

        if (values.procedencia === 'Aseguradora' && values.importe < 150) {
            var agente_data = await axios.get('https://staging.traspasatupoliza.es/api/get_all_data_from_user/d5e11562_bb66_43e3_8f83_1b0a23dda010/' + values.nombre_agente)
            if (agente_data.data.punto_venta != '0800005') {
                setbuttonLoading(false);
                api.info({
                    message: 'Error',
                    description: texts[language].error_minimum,
                    placement: 'bottom',
                    icon: (
                        <CloseCircleOutlined style={{ color: "#f7151c" }} />
                    )
                });
                return;
            }
        }

        axios.post(process.env.REACT_APP_URL_CALCULO_RAPIDO, values, {
            headers: headers
        })
            .then(function (response) {
                if (response.data.message === "OK") {
                    setDatosForm(values);
                    if (values.procedencia === 'NoSeguro') {
                        setPriceBasic(response.data.priceData.priceBasic);
                        setPricePremium(response.data.priceData.pricePremium);
                    } else {
                        setPriceBasic(null);
                        setPricePremium(null);
                    }

                    setbuttonLoading(false);
                    setSuccess(true);
                    setPaso(1);
                    console.log(values);
                }
            })
            .catch(function () {
                openNotification('bottom')
                setbuttonLoading(false);
            });
    };

    const onChange = (e) => {
        setValue(e.target.value);
        if (e.target.value === 'NoSeguro') {
            setIsBanco(false);
        } else setIsBanco(true);
    };

    const openNotification = (placement) => {
        api.info({
            message: texts[language].error,
            description:
                texts[language].error_description,
            placement,
            icon: (
                <CloseCircleOutlined style={{ color: "#f7151c" }} />
            )
        });
    };

    const customParser = (value) => {
        // Reemplaza comas por puntos
        const processedValue = value.replace(/,/g, '.');
      
        // Analiza el valor en un número de punto flotante
        const parsedValue = parseFloat(processedValue);
      
        // Asegúrate de que el resultado es un número
        if (!isNaN(parsedValue)) {
          return parsedValue;
        }
      
        return undefined; // Si no se pudo analizar, devuelve undefined
      };

    return (
        <>
            {contextHolder}
            <ConfigProvider
                locale={esES}
                theme={{
                    token: {
                        colorPrimary: primaryColor,
                    },
                }}
            >
                <style>
                    {`
                    ::-webkit-scrollbar {
                        display: none;
                    }
                    `}
                </style>
                <div ref={refForm}>
                    <Form
                        form={form}
                        style={{ padding: '1.5rem' }}
                        hidden={success}
                        name="basic"
                        initialValues={{ remember: true }}
                        layout='vertical'
                        onFinish={onFinish}
                        requiredMark={false}
                    >
                        <Form.Item
                            hidden={true}
                            label="URL"
                            name="url"
                        >
                            <Input type='text' />
                        </Form.Item>

                        <Form.Item
                            hidden={true}
                            label="nombre_agente"
                            name="nombre_agente"
                        >
                            <Input type='text' />
                        </Form.Item>

                        <Form.Item
                            hidden={true}
                            label="FB"
                            name="fbp">
                            <Input type='' />
                        </Form.Item>

                        <Form.Item
                            hidden={true}
                            label="Hubspotutk"
                            name="hubspotutk">
                            <Input type='' />
                        </Form.Item>

                        <Form.Item
                            hidden={true}
                            label="userAgent"
                            name="userAgent">
                            <Input type='' />
                        </Form.Item>
                        {!NotEnsureFields && (
                            <Form.Item
                                label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>{texts[language].p1}</p>}
                                name="importe"
                                style={{ marginBottom: "0.6rem" }}
                                colon={false}
                                rules={[{ required: true, message: texts[language].rule1 }]}

                                
                            >
                                {/* Se debe permitir tanto comas como puntos como separador decimal */}
                                <InputNumber style={{ width: '100%' }} placeholder='700' disabled={buttonLoading} parser={customParser} />
                            </Form.Item>
                        )}
                        <Form.Item
                            label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>{texts[language].p2}</p>}
                            name="procedencia"
                            style={{ marginBottom: "0.6rem" }}
                            rules={[{ required: true, message: texts[language].rule2 }]}
                            initialValue="Banco"
                        >
                            <Radio.Group onChange={onChange} value={value}>
                                <Space
                                    direction='vertical'
                                    style={{ marginLeft: '1rem' }}
                                >
                                    <Radio value={"Banco"}>{texts[language].p2_1}</Radio>
                                    <Radio value={"Aseguradora"}>{texts[language].p2_2}</Radio>
                                    <Radio value={"NoSeguro"}>{texts[language].p2_3}</Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>

                        {/* Este mensaje se debe ver si el usuario ha seleccionado la opción "No tengo seguro a día de hoy" o "Aseguradora" */}
                        <div style={{ display: `${isBanco ? 'none' : 'block'}` }}>
                            <Alert style={{marginTop: "15px", marginBottom: "15px"}} message={texts[language].p2_alert} type="error" />
                        </div>

                        {NotEnsureFields && (
                            <>
                                <Form.Item
                                    label="Fecha de nacimiento"
                                    name="birthday"
                                    rules={[{ required: true, message: 'Ingresa su fecha de nacimiento' }]}
                                >
                                    <DatePicker defaultPickerValue={dayjs().subtract(18, 'years')} disabledDate={disabledDateBefore18YearsAgo} style={{ width: '100%' }} format={dateFormat} onChange={handleBirthdayChange} showToday={false} />
                                </Form.Item>

                                <Form.Item
                                    label="Cantidad que quieres asegurar"
                                    name="capital_to_ensure"
                                    initialValue={50000}
                                    rules={[
                                        { required: true, message: 'Ingresa la cantidad que quieres asegurar' },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const age = calculateAge(getFieldValue('birthday'));

                                                if (age >= 18 && age <= 59) {
                                                    if (value < 50000 || value > 500000) {
                                                        return Promise.reject(new Error('La cantidad debe ser entre 50.000 y 500.000'));
                                                    }
                                                } else if (age >= 60 && age <= 74) {
                                                    if (value < 10000 || value > 50000) {
                                                        return Promise.reject(new Error('La cantidad debe ser entre 10.000 y 50.000'));
                                                    }
                                                } else {
                                                    // Edad mayor de 74 años, bloquea el campo
                                                    return Promise.reject(new Error('Los mayores a 74 años no pueden realizar un seguro'));
                                                }

                                                return Promise.resolve();
                                            },
                                        }),
                                    ]}
                                >
                                    <InputNumber style={{ width: '100%' }} />
                                </Form.Item>
                            </>
                        )}

                        <Form.Item
                            label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>{texts[language].p3}</p>}
                            name="tel"
                            style={{ marginBottom: "0.6rem" }}
                            rules={[{ required: true, message: texts[language].rule3 }]}
                        >
                            <Input maxLength={9} minLength={9} placeholder='619 99 31 31' type='tel' disabled={buttonLoading} />
                        </Form.Item>

                        <Form.Item
                            label={<p style={{ fontSize: "15px", marginTop: "-6px", marginBottom: "-6px" }}>{texts[language].p4}</p>}
                            name="email"
                            style={{ marginBottom: "0.6rem" }}
                            rules={[{ required: true, message: texts[language].rule4 }]}
                        >
                            <Input placeholder={texts[language].placeholder4} type='email' disabled={buttonLoading} />
                        </Form.Item>

                        <Form.Item style={{ marginBottom: "0.6rem" }} valuePropName="checked" name="terms" initialValue={false} rules={[{ required: true, validator: async (_, checked) => { if (!checked) { return Promise.reject(new Error(texts[language].rule5)); } } }]}>
                            <Checkbox style={{ fontSize: "15px" }} disabled={buttonLoading} >{texts[language].p5_1} <Link target='_blank' to='https://www.coventia.es/politica-de-privacidad-y-aviso-de-cookies'>{texts[language].p5_2}</Link></Checkbox>
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "0.6rem", width: '100%', marginTop: '1rem' }}
                            disabled={!isBanco}
                        >
                            <Button disabled={!isBanco} type='primary' loading={buttonLoading} htmlType="submit" style={{ width: "100%", height: "35px" }}>
                                {buttonLoading ? texts[language].sending : texts[language].button}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>

                <div style={{ display: `${paso === 1 ? 'block' : 'none'}` }}>
                    <ResultParte1 datos={datosForm} priceBasic={priceBasic} pricePremium={pricePremium} onClick={() => setPaso(2)} language={language} />
                </div>

                <div style={{ display: `${paso === 2 ? 'block' : 'none'}` }}>
                    <FormularioParte2 datos={datosForm} setDatosForm={setDatosForm} onClick={() => { setPaso(3); }} language={language} />
                </div>

                <div style={{ display: `${paso === 3 ? 'block' : 'none'}` }}>
                    <ResultParte2 datos={datosForm} onClick={() => { setPaso(4); }} language={language} />
                </div>

                <div style={{ display: `${paso === 4 ? 'block' : 'none'}` }}>
                    <FormularioParte3 datos={datosForm} onClick={() => { setPaso(5); }} language={language} />
                </div>

                <div style={{ display: `${paso === 5 ? 'block' : 'none'}` }}>
                    <ResultPaginaPrincipalParte3 datos={datosForm} language={language} />
                </div>
            </ConfigProvider>

        </>
    );
}

export default LandingCaserInsurcab;